const adminRoutes = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { user: ['Administrator', 'SchoolStaff', 'Student'] }
    },
    {
        path: '/user-profile',
        name: 'User Profile',
        component: () => import('@/views/UserProfile.vue'),
        meta: { user: ['Administrator', 'SchoolStaff', 'Student'] }
    },
    {
        path: '/admin/staff-registration',
        name: 'Staff Registration',
        component: () => import('@/views/PortalAdmin/AdminUser.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/sms',
        name: 'SMS',
        component: () => import('@/views/PortalAdmin/SMS/Index.vue'),
        meta: { user: 'Administrator' }
    },    
    {
        path: '/admin/sms/school',
        name: 'School',
        component: () => import('@/views/PortalAdmin/SMS/Component/School.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/sms/school-subject',
        name: 'School Subjects Registrations',
        component: () => import('@/views/PortalAdmin/SMS/Component/Subjectsetup.vue'),
        meta: { user: 'Administrator' }
    },
     {
        path: '/admin/eduschool',
        name: 'EduSchool',
        component: () => import('@/views/PortalAdmin/EduSchool/Index.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/eduschool/news-setup',
        name: 'Eduschool News',
        component: () => import('@/views/PortalAdmin/EduSchool/Component/NewsSetup.vue'),
        meta: { user: 'Administrator' }
    },
     {
        path: '/admin/eduschool/class-note-setup',
        name: 'Class Note',
        component: () => import('@/views/PortalAdmin/EduSchool/Component/ClassNoteSetup.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/eduschool/class-note-lesson-setup',
        name: 'Class Note Lesson',
        component: () => import('@/views/PortalAdmin/EduSchool/Component/ClassNoteLessonSetup.vue'),
        meta: { user: 'Administrator' }
    },
     {
        path: '/admin/eduschool/class-note-lesson-question-setup',
        name: 'Class Note Lesson Question',
        component: () => import('@/views/PortalAdmin/EduSchool/Component/ClassNoteLessonQuestionSetup.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/school-staff-registrations',
        name: 'School Staff Registrations',
        component: () => import('@/views/PortalAdmin/Schoolstaff.vue'),
        meta: { user: 'Administrator' }
    },
    
    {
        path: '/admin/eduschool/eduschool-exam-prep',
        name: 'Exam Prep',
        component: () =>
            import('@/views/PortalAdmin/EduSchool/Component/ExamPrepExam.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/eduschool/eduschool-exam-prep/subject',
        name: 'EduSchool CBT Subject',
        component: () =>
            import('@/views/PortalAdmin/EduSchool/Component/ExamPrepSubject.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/eduschool/eduschool-exam-prep/subject/questions',
        name: 'EduSchool CBT Questions',
        component: () =>
            import('@/views/PortalAdmin/EduSchool/Component/ExamPrepQuestion.vue'),
        meta: { user: 'Administrator' }
    },
     {
        path: '/admin/eduschool/school-subjects',
        name: 'School Subjects',
        component: () =>
            import('@/views/PortalAdmin/EduSchool/Component/SchoolSubject.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/privacy-setup',
        name: 'Privacy Setup',
        component: () =>
            import('@/views/PortalAdmin/Privacy.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/sms-subscriptions-setup',
        name: 'SMS Subscriptions Setup',
        component: () =>
            import('@/views/PortalAdmin/SmsSub.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/eduschool/community-setup',
        name: 'Eduschool Community',
        component: () =>
            import('@/views/PortalAdmin/EduSchool/Component/Community.vue'),
        meta: { user: 'Administrator' }
    },
    {
        path: '/admin/eduschool/notification-sender',
        name: 'Notification Sender',
        component: () =>
            import('@/views/PortalAdmin/EduSchool/Component/NotificationSender.vue'),
        meta: { user: 'Administrator' }
    },
]

export default adminRoutes
